import { ControlInputFieldProps } from "components/Form/typings";

import Trix from "trix";
import { useRef } from "react";
import EmbeddedHtml from "components/DataDisplay/EmbeddedHtml";
import GreyBlackField from "components/DataDisplay/GreyBlackField";
import TrixTextAreaField from "../TrixTextAreaField";

type RichTextAreaFieldProps = ControlInputFieldProps & {
  hideToolbar?: boolean;
  alwaysShowToolbar?: boolean;
  hideAttachment?: boolean;
  disabled?: boolean;
  toolbarBgColor?: string;
  editorBgColor?: string;
};

export default function RichTextAreaField(props: RichTextAreaFieldProps) {
  const {
    hideToolbar, alwaysShowToolbar, disabled = false, hideAttachment = false, toolbarBgColor, editorBgColor, ...rest
  } = props;
  const trixRef = useRef<Trix>(null);

  return (
    <TrixTextAreaField
      {...rest}
      ref={trixRef}
      isEditable={!disabled}
      includeAttachment={!hideAttachment}
      hideToolbar={hideToolbar}
      alwaysShowToolbar={alwaysShowToolbar}
      toolbarBgColor={toolbarBgColor}
      editorBgColor={editorBgColor}
    />
  );
}

export function ShowRichText({ label, richText }: { label: string; richText: string }) {
  return (
    <GreyBlackField label={label} bgColor="bg.tertiary" borderRadius="6px" px="4" py="3">
      <EmbeddedHtml innerHtml={richText} />
    </GreyBlackField>
  );
}
